  <select style="width:100%;" class="form-select" [ngModel]="lang | async" (change)="change($event.target.value)">
    <option *ngFor="let language of languages" [value]="language.abbreviation"> {{ language.name }}</option>
  </select>
